const Translation = {
    id:{
        "SaasClient":"Klien SaaS",
        "saas_client":"Klien SaaS",
        "SaasClient.name":"Nama Klien",
        "SaasClient.domain":"Domain",
        "SaasClient.host":"Host",
        "SaasClient.title":"Judul",
        "SaasClient.defaultPage":"Halaman Utama",
        "SaasClient.loginBackground":"Background Login",
        "SaasClient.favicon":"Favicon",
        "SaasClient.companyLogo":"Logo Form Login",
        "SaasClient.loginLogo":"Logo Navbar Login",
        "SaasClient.sidebarLogo":"Logo Sidebar",
        "SaasClient.loginCardColor":"Latar Belakang Logo Login",
        "SaasClient.loginButtonColor":"Tombol Login",
        "SaasClient.activeSidebarColor":"Menu yang Aktif",
        "SaasClient.activeMenuShadowColor":"Warna Bayangan Menu yang Aktif",
        "SaasClient.blogFontName":"Nama Font Editor Blog",
        "SaasClient.blogFontFile":"Berkas Font Editor Blog",
        "SaasClient.attachmentStorage":"Penyimpanan Lampiran",
        "SaasClient.accounting":"Akunting",
        "SaasClient.property":"Properti",
        "SaasClient.hr":"HR",
        "SaasClient.base":"Admin",
        "SaasClient.shop":"Toko Online",
        "SaasClient.web":"Web",
        "SaasClient.freight":"Kargo",
        "SaasClient.realEstate":"Real Estate",
        "SaasClient.themePark":"Taman Bermain",
        "SaasClient.bakery":"Toko Roti",
        "SaasClient.restaurant":"Restoran",
        "SaasClient.debug":"Debug",
        "SaasClient.saasCenter":"Pusat SaaS",
        "SaasClient.hideAccounting":"Sembunyikan Akunting",
        "SaasClient.state":"Status",
        "SaasClient.webUrl":"URL Situs Web",
        "SaasClient.externalServices":"Layanan Eksternal",
        "SaasClient.mapsApiKey":"Google Maps API Key",
        "SaasClient.accountingOptions":"Pengaturan Akunting",
        "SaasClient.instantSalesItemPick":"Mode Pemilihan Barang di Penjualan Instan",
        "SaasClient.instantSalesStrictMode":"POS Ketat",
        "SaasClient.advancedProcurement":"Pengadaan Lanjutan",
        "SaasClient.accumulateItems":"Akumulasi Barang yang Sama",
        "SaasClient.separateBranchAccounting":"Akunting Cabang Terpisah",
        "SaasClient.unitRepresentedByAnItem":"Satu Barang Untuk Satu Satuan",
        "SaasClient.center":"Pusat",
        "SaasClient.branchCode":"Kode Cabang",
        "SaasClient.centralAndBranches":"Pusat & Cabang",
        "SaasClient.disableMarketplace":"Nonaktifkan Marketplace",
        "SaasClient.images":"Gambar",
        "SaasClient.colors":"Warna",
        "SaasClient.fonts":"Font",
        "SaasClient.modules":"Modul",
        "SaasClient.storage":"Penyimpanan",
        "SaasClient.offlineMode":"Mode Offline",
        "SaasClient.enableOfflineMode":"Aktifkan Mode Offline",
        "SaasClient.offlineModeURL":"URL Mode Offline",
        "SaasClient.manualPaymentInfo":"Informasi Pembayaran Manual",
        "SaasClient.bank":"Nama Bank",
        "SaasClient.bankName":"Nama Rekening",
        "SaasClient.bankAccount":"Nomor Rekening",
        "SaasClient.autoApplyPromotion":"Terapkan Promo Otomatis",
        "SaasClient.UIHide":"Sembunyikan Dari Antarmuka",
        "SaasClient.hideBrowserFields":"Sembunyikan Kolom Tabel",
        "SaasClient.hideFormFields":"Sembunyikan Kolom Form",
        "SaasClient.hideFromMenu":"Sembunyikan Dari Menu",

        //App
        "App":"Aplikasi",
        "App.name":"Nama",
        "App.packageName":"Nama Paket",
        "App.platform":"Platform",
        "App.state":"Status",
        "App.activate":"Aktifkan",
        "App.deactivate":"Nonaktifkan",
        "App.confirmTitle.action/activate":"Aktifkan",
        "App.confirmContent.action/activate":"Apa Anda yakin akan mengaktifkan aplikasi ini?",
        "App.success.action/activate":"Aplikasi telah berhasil diaktifkan",
        "App.confirmTitle.action/deactivate":"Nonaktifkan",
        "App.confirmContent.action/deactivate":"Apa Anda yakin Akan menonaktifkan aplikasi ini?",
        "App.success.action/deactivate":"Aplikasi telah berhasil dinonaktifkan",

        //App Release
        "AppRelease":"Rilis Aplikasi",
        "AppRelease.version":"Nomor Versi (Semantik)",
        "AppRelease.app":"Aplikasi",
        "AppRelease.changeLog":"Log Perubahan",
        "AppRelease.file":"Berkas",
        "AppRelease.state":"Status",
        "AppRelease.activate":"Aktifkan",
        "AppRelease.deactivate":"Nonaktifkan",
        "AppRelease.confirmTitle.action/activate":"Aktifkan",
        "AppRelease.confirmContent.action/activate":"Apa Anda yakin akan mengaktifkan Rilis aplikasi ini?",
        "AppRelease.success.action/activate":"Rilis Aplikasi berhasil diaktifkan",
        "AppRelease.confirmTitle.action/deactivate":"Nonaktifkan",
        "AppRelease.confirmContent.action/deactivate":"Apa Anda yakin akan menonaktifkan Rilis Aplikasi ini?",
        "AppRelease.success.action/deactivate":"Rilis Aplikasi berhasil dinonaktifkan",

        //options
        "filesystem":"Filesystem",
        "database":"Database",
        "s3":"Amazon S3",
        "simple":"Sederhana",
        "detailed":"Detil",
        "branch":"Detil Cabang"
    },
    en:{
        "SaasClient":"SaaS Client",
        "saas_client":"Saas Client",
        "SaasClient.name":"Client Name",
        "SaasClient.domain":"Domain",
        "SaasClient.host":"Host",
        "SaasClient.title":"Title",
        "SaasClient.defaultPage":"Default Page",
        "SaasClient.loginBackground":"Login Background",
        "SaasClient.favicon":"Favicon",
        "SaasClient.companyLogo":"Login Form Logo",
        "SaasClient.loginLogo":"Login Navbar Logo",
        "SaasClient.sidebarLogo":"Sidebar Logo",
        "SaasClient.loginCardColor":"Login Logo Background",
        "SaasClient.loginButtonColor":"Login Button Color",
        "SaasClient.activeSidebarColor":"Active Menu",
        "SaasClient.activeMenuShadowColor":"Active Menu Shadow Color",
        "SaasClient.blogFontName":"Blog Font Name",
        "SaasClient.blogFontFile":"Blog Font File",
        "SaasClient.attachmentStorage":"Attachment Storage",
        "SaasClient.accounting":"Accounting",
        "SaasClient.property":"Property",
        "SaasClient.hr":"HR",
        "SaasClient.base":"Admin",
        "SaasClient.shop":"Online Shop",
        "SaasClient.web":"Web",
        "SaasClient.freight":"Freight",
        "SaasClient.realEstate":"Real Estate",
        "SaasClient.themePark":"Theme Park",
        "SaasClient.bakery":"Bakery",
        "SaasClient.restaurant":"Restaurant",
        "SaasClient.debug":"Debug",
        "SaasClient.saasCenter":"SaaS Center",
        "SaasClient.hideAccounting":"Hide Accounting",
        "SaasClient.state":"Status",
        "SaasClient.webUrl":"Website URL",
        "SaasClient.externalServices":"External Services",
        "SaasClient.mapsApiKey":"Google Maps API Key",
        "SaasClient.accountingOptions":"Accounting Options",
        "SaasClient.instantSalesItemPick":"Item Selection Mode in Instant Sales",
        "SaasClient.instantSalesStrictMode":"Strict POS",
        "SaasClient.advancedProcurement":"Advanced Procurement",
        "SaasClient.accumulateItems":"Accumulate Same Items",
        "SaasClient.separateBranchAccounting":"Separate Branch Accounting",
        "SaasClient.unitRepresentedByAnItem":"Unit Represented By An Item",
        "SaasClient.center":"Center",
        "SaasClient.branchCode":"BranchCode",
        "SaasClient.centralAndBranches":"Central And Branches",
        "SaasClient.unitRepresentedByAnItem":"Unit Represented by An Item",
        "SaasClient.disableMarketplace":"Disable Marketplace",
        "SaasClient.images":"Images",
        "SaasClient.colors":"Colors",
        "SaasClient.fonts":"Fonts",
        "SaasClient.modules":"Modules",
        "SaasClient.storage":"Storage",
        "SaasClient.offlineMode":"Offline Mode",
        "SaasClient.enableofflineMode":"Enable Offline Mode",
        "SaasClient.offlineModeURL":"Offline Mode URL",
        "SaasClient.manualPaymentInfo":"Manual Payment Information",
        "SaasClient.bank":"Bank Name",
        "SaasClient.bankName":"Account Name",
        "SaasClient.bankAccount":"Account Number",
        "SaasClient.autoApplyPromotion":"Automatically Apply Promotion",
        "SaasClient.UIHide":"Hide From User Interface",
        "SaasClient.hideBrowserFields":"Hide Browser Fields",
        "SaasClient.hideFormFields":"Hide Form Fields",
        "SaasClient.hideFromMenu":"Hide From Menu",

        //App
        "App":"Application",
        "App.name":"Name",
        "App.packageName":"Package Name",
        "App.platform":"Platform",
        "App.state":"Status",
        "App.activate":"Activate",
        "App.deactivate":"Deactivate",
        "App.confirmTitle.action/activate":"Activate",
        "App.confirmContent.action/activate":"Are you sure want to activate this app?",
        "App.success.action/activate":"App is successfuly activated",
        "App.confirmTitle.action/deactivate":"Deactivate",
        "App.confirmContent.action/deactivate":"Are you sure want to deactivate this app?",
        "App.success.action/deactivate":"App is successfully deactivated",

        //App Release
        "AppRelease":"App Releases",
        "AppRelease.version":"Version Number (Semantic)",
        "AppRelease.app":"Application",
        "AppRelease.changeLog":"Change Log",
        "AppRelease.file":"File",
        "AppRelease.state":"Status",
        "AppRelease.activate":"Activate",
        "AppRelease.deactivate":"Deactivate",
        "AppRelease.confirmTitle.action/activate":"Nonaktifkan",
        "AppRelease.confirmContent.action/activate":"Nonaktifkan",
        "AppRelease.success.action/activate":"Nonaktifkan",
        "AppRelease.confirmTitle.action/deactivate":"Nonaktifkan",
        "AppRelease.confirmContent.action/deactivate":"Nonaktifkan",
        "AppRelease.success.action/deactivate":"Nonaktifkan",

        //options
        "filesystem":"Filesystem",
        "database":"Database",
        "s3":"Amazon S3",
        "simple":"Simple",
        "detailed":"Detailed",
        "branch":"Detailed Branch",
    }
}

export default Translation